<ui-section class="height-100" [title]="config.gaugeName || (config.businessIndicatorId | businessIndicator)?.name">
    <ui-section-content>
        <div class="flex-row justify-center height-100">
            @if (data.value()) {
                <div class="gauge-container">
                    <highcharts-chart class="chart" [options]="chartOptions" [destroyChart]="true" [autoReflow]="true" />
                </div>
                @if (displayLegend()) {
                    <div class="legend">
                        @for (bandBoundary of bandBoundaries; track bandBoundary.bandBoundaryId) {
                            <div class="flex-row gap-1 align-center">
                                <div class="category-circle mr-1" [style.background-color]="bandBoundary.color"></div>
                                @if ($index !== bandBoundaries.length - 1) {
                                    <div class="legend-label">
                                        {{
                                            `${bandBoundary.name ?? ('PAGES.BUSINESS_INDICATORS.WIDGETS.GAUGE.BOUNDS_TYPE.' + bandBoundary.code | uppercase | translate)} ${bandBoundary.year ?? ''} :`
                                        }}
                                    </div>
                                    <div class="legend-text">
                                        {{ 'TAILORED_WIDGET.INDICATOR_GAUGE.FROM' | translate }}
                                        {{ bandBoundary.from | significantDigits | localnumber }}
                                        {{ 'TAILORED_WIDGET.INDICATOR_GAUGE.TO' | translate }}
                                        {{ bandBoundary.to | significantDigits | localnumber }} {{ data.value()?.displayUnitCode }}
                                    </div>
                                } @else {
                                    <div class="legend-label">
                                        {{ bandBoundary.name ? `${bandBoundary.name} ${bandBoundary.year ?? ''} :` : '' }}
                                    </div>
                                    <div class="legend-text">
                                        {{ 'TAILORED_WIDGET.INDICATOR_GAUGE.MORE_THAN' | translate }}
                                        {{ bandBoundary.from | significantDigits | localnumber }} {{ data.value()?.displayUnitCode }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            } @else {
                <loading-and-error [resource]="data" />
            }
        </div>
    </ui-section-content>
</ui-section>
